import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'

type ISummaryItemDTO = {
  selection: (string | Record<string, unknown>)[]
  step: {
    num: number
    name: string
    type: string
  }
}

class SummaryItemDTO {
  selection: (string | Record<string, unknown>)[]
  step: {
    num: number
    name: string
    type: string
  }

  constructor(data: ISummaryItemDTO) {
    this.selection = data.selection
    this.step = data.step
  }
}

export type ISummaryDTO = {
  delivery_date: number
  delivery_days: number
  total_price: number
  total_price_formatted?: string
  total_price_consumer: number
  total_price_consumer_formatted?: string
  attributes: Record<string, unknown>
  products: number[]
  summary: unknown[]
}

export class SummaryDTO {
  deliveryDate: number
  deliveryDays: number
  totalPrice: number
  totalPriceFormatted: string | undefined
  totalPriceConsumer: number
  totalPriceConsumerFormatted: string | undefined
  attributes: Record<string, unknown>
  products: number[]
  summary: SummaryItemDTO[]

  constructor(data: ISummaryDTO) {
    this.deliveryDate = data.delivery_date
    this.deliveryDays = data.delivery_days
    this.totalPrice = data.total_price
    this.totalPriceFormatted = data.total_price_formatted
    this.totalPriceConsumer = data.total_price_consumer
    this.totalPriceConsumerFormatted = data.total_price_consumer_formatted
    this.attributes = data.attributes
    this.products = data.products
    this.summary = data.summary.map(parseSummaryItemDTO)
  }
}

const validateSummaryItemDTO = createValidate<ISummaryItemDTO>()

export const parseSummaryItemDTO = (data: unknown) => {
  validateGuard(validateSummaryItemDTO, data, 'SummaryItemDTO')
  return new SummaryItemDTO(data)
}

const validateSummaryDTO = createValidate<ISummaryDTO>()

export const parseSummaryDTO = (data: unknown) => {
  validateGuard(validateSummaryDTO, data, 'SummaryDTO')
  return new SummaryDTO(data)
}
